module.exports = __webpack_public_path__ + "img/LoRa Icon.bd1d86e4.png";